/**
 * Форма «Оплата от юрлица» — модалка `template/modals/corporate-payment.php`.
 *
 * Модалка подключается в шести шаблонах: `page-basic-coaching`,
 * `page-new-basic-course` (`/pkmu/`, `/prodvinutyy-coaching/`),
 * `page-pcc`, `page-promotion-basics`, `page-silavslove` и
 * `page-templates/documents.php` (только `/org/sposoby-oplaty/`).
 *
 * Раньше обработчик жил в трёх копиях: `assets/js/page-basic-coaching.js`,
 * `assets/js/page-promotion-basics.js`, `src/js/pages/documents.js`.
 * Копии различались только метками, они сведены в `PAGES` ниже
 * ДОСЛОВНО — менять их значит менять отчёты в GetCourse.
 *
 * Открытие модалки (`Modals`) этот модуль НЕ поднимает: на курсах
 * это делают легаси-скрипты страниц, на документах — `pages/documents.js`.
 * Второй экземпляр `Modals` открывал бы модалку дважды.
 *
 * ⚠️ `initCustomForm` — глобальная функция обычного скрипта
 * `assets/js/custom-form.js`, нужен набор `prism_enqueue_set('custom-form')`.
 */

/**
 * Метки по странице. Ключ — путь без слэшей, как в прежнем коде
 * (`pathname.replaceAll('/', '')`).
 *
 * `utm_term` у документов не было — ключ не задан намеренно:
 * `initCustomForm` отправит пустую строку, как и раньше.
 */
const PAGES = {
    'basic-coaching':       { utm_content: 'basicscoaching',   utm_term: 'plaskakurs' },
    'prodvinutyy-coaching': { utm_content: 'pkmu.2step',       utm_term: 'plaskakurs' },
    'pkmu':                 { utm_content: 'pkmu',             utm_term: 'plaskakurs' },
    'silavslove':           { utm_content: 'powerisintheword', utm_term: 'plaskakurs' },
    'pcc':                  { utm_content: 'pcc',              utm_term: 'plaskakurs' },
    'promotion-basics':     { utm_content: 'promotion',        utm_term: 'plaskakurs' },
    'orgsposoby-oplaty':    { utm_content: 'sposoby-oplaty',   comment: 'Страница' },
};

export default function CorporatePayment() {
    const container = document.querySelector('.custom-form--corporate-payment');
    if (!container) return;

    if (typeof initCustomForm !== 'function') {
        console.error('corporate-payment: не подключён assets/js/custom-form.js (набор custom-form)');
        return;
    }

    const url = window.location.origin + window.location.pathname;
    const { comment = 'Курс', ...utm } = PAGES[window.location.pathname.replaceAll('/', '')] || {};

    const handleResponse = (response) => {
        const result = response.result;

        if (result.success) {
            customFormMessageSuccess(container);
        }

        if (result.error) {
            console.error(response);
            customFormMessageError(container, 'Произошла ошибка при отправке заявки, попробуйте позднее');
        }
    };

    initCustomForm(
        container,
        '/gc/gc-post.php',
        {
            utm_source: 'seo',
            utm_medium: 'organic',
            utm_campaign: 'form-corporate-payment',
            ...utm,
        },
        handleResponse,
        {
            comment: `${comment}: ${url}`,
        },
    );
}
